import dayjs from 'dayjs'
import { cloneDeep, orderBy } from 'lodash'
import { currency } from 'src/data/currency'

function getInvoiceTotals(
	invoices,
	currencyRates,
	companyInfo,
	startDate,
	endDate
) {
	console.log('invoices: ', invoices)
	if (!invoices || invoices?.length === 0) return
	let totalsObject = {}
	let currencySymbol
	if (Object.keys(companyInfo).length !== 0) {
		const currentCurrency = currency.filter(
			(c) => c.code === (companyInfo?.accountCurrency || 'EUR')
		)[0]
		currencySymbol = currentCurrency?.symbol
	}
	let cloneInvoices
	if (startDate && endDate) {
		const copyInvoicesData = cloneDeep(invoices)

		cloneInvoices = copyInvoicesData.filter(
			(pd) =>
				dayjs(pd.invoiceDate).isAfter(dayjs(startDate)) &&
				dayjs(pd.invoiceDate).isBefore(dayjs(endDate))
		)
	} else {
		cloneInvoices = cloneDeep(invoices)
	}

	const convertRatesInvoices = cloneInvoices.map((i) => {
		const filteredRate = currencyRates?.[0]?.rates?.filter(
			(r) => r.currencyName === i.clientCurrency
		)

		let rate
		if (filteredRate && filteredRate.length > 0) {
			rate = filteredRate[0]
		} else {
			rate = {
				currencyRate: 1,
			}
		}
		const newConvertedAmount = (
			(parseFloat(i?.taxAmount?.toFixed(2)) +
				parseFloat(i?.amount?.toFixed(2))) /
			parseFloat(rate.currencyRate)
		)?.toFixed(2)
		i.convertedAmount = parseFloat(newConvertedAmount)

		const newConvertedTaxAmount = (
			parseFloat(i.taxAmount) / parseFloat(rate.currencyRate)
		)?.toFixed(2)
		i.convertedTaxAmount = parseFloat(newConvertedTaxAmount)
		const newConvertedAmountBeforeTax = (
			parseFloat(i.amount) / parseFloat(rate.currencyRate)
		)?.toFixed(2)
		i.convertedAmountBeforeTax = parseFloat(newConvertedAmountBeforeTax)

		const copyTaxDetails = cloneDeep(i.taxDetails)

		copyTaxDetails.map((td) => {
			if (!td.taxAmount) {
			}
			const taxAmount = (
				parseFloat((td?.taxAmount || 0)?.toFixed(2)) /
				parseFloat(rate.currencyRate)
			)?.toFixed(2)
			td.taxAmount = parseFloat(taxAmount)
			if (td.taxableAmount != null) {
				td.taxableAmount = parseFloat(
					(
						parseFloat((td.taxableAmount || 0).toFixed(2)) /
						parseFloat(rate.currencyRate)
					).toFixed(2)
				)
			}
			return td
		})
		i.copyTaxDetails = copyTaxDetails
		const copySectionDetailsByQuote = cloneDeep(i.sectionDetailsByQuote)
		if (copySectionDetailsByQuote && copySectionDetailsByQuote.length > 0) {
			copySectionDetailsByQuote.map((sd) => {
				const amount = (
					parseFloat((sd.amount || 0)?.toFixed(2)) /
					parseFloat(rate.currencyRate)
				)?.toFixed(2)
				sd.amount = parseFloat(amount)
				return sd
			})
		}
		i.copySectionDetailsByQuote = copySectionDetailsByQuote
		const copySectionDetailsByAccSection = cloneDeep(
			i.sectionDetailsByAccSection
		)
		if (
			copySectionDetailsByAccSection &&
			copySectionDetailsByAccSection.length > 0
		) {
			copySectionDetailsByAccSection.map((sd) => {
				const amount = (
					parseFloat((sd.amount || 0)?.toFixed(2)) /
					parseFloat(rate.currencyRate)
				)?.toFixed(2)
				sd.amount = parseFloat(amount)
				return sd
			})
		}
		i.copySectionDetailsByAccSection = copySectionDetailsByAccSection

		return i
	})

	const creditTotal = convertRatesInvoices
		.filter((i) => i.invoiceType === 'credit')
		.reduce((a, b) => a + parseFloat(b.convertedAmount || 0), 0)
	const invoiceTotal = convertRatesInvoices
		.filter((i) => i.invoiceType !== 'credit')
		.reduce((a, b) => a + parseFloat(b.convertedAmount), 0)
	const creditNetTotal = convertRatesInvoices
		.filter((i) => i.invoiceType === 'credit')
		.reduce((a, b) => a + parseFloat(b.convertedAmountBeforeTax || 0), 0)
	const invoiceNetTotal = convertRatesInvoices
		.filter((i) => i.invoiceType !== 'credit')
		.reduce((a, b) => a + parseFloat(b.convertedAmountBeforeTax), 0)

	const totalAmount = (invoiceTotal - creditTotal)?.toFixed(2)
	const netAmount = (invoiceNetTotal - creditNetTotal)?.toFixed(2)
	totalsObject = {
		convertedInvoices: convertRatesInvoices,
		currencySymbol,
		totalAmount,
		netAmount,
	}

	return totalsObject
}
function getInvoiceTotalsByMonth(
	invoices,
	currencyRates,
	companyInfo,
	startYear = `${dayjs().get('year')}`,
	endYear = `${dayjs().get('year') + 1}`
) {
	if (!invoices || invoices?.length === 0) return
	let totalsObject = {}
	let currencySymbol
	if (Object.keys(companyInfo).length !== 0) {
		const currentCurrency = currency.filter(
			(c) => c.code === (companyInfo?.accountCurrency || 'EUR')
		)[0]
		currencySymbol = currentCurrency?.symbol
	}
	let cloneInvoices
	if (startYear && endYear) {
		const startDate = dayjs(`1/1/${startYear}`)
		const endDate = dayjs(`1/1/${endYear}`)
		const copyInvoicesData = cloneDeep(invoices)

		cloneInvoices = copyInvoicesData.filter(
			(pd) =>
				dayjs(pd.invoiceDate).isAfter(dayjs(startDate)) &&
				dayjs(pd.invoiceDate).isBefore(dayjs(endDate))
		)
	} else {
		cloneInvoices = cloneDeep(invoices)
	}

	const convertRatesInvoices = cloneInvoices.map((i) => {
		const filteredRate = currencyRates?.[0]?.rates?.filter(
			(r) => r.currencyName === i.clientCurrency
		)

		let rate
		if (filteredRate && filteredRate.length > 0) {
			rate = filteredRate[0]
		} else {
			rate = {
				currencyRate: 1,
			}
		}
		const newConvertedAmount = (
			(parseFloat(i?.taxAmount?.toFixed(2)) +
				parseFloat(i?.amount?.toFixed(2))) /
			parseFloat(rate.currencyRate)
		)?.toFixed(2)
		i.convertedAmount = parseFloat(newConvertedAmount)

		const newConvertedTaxAmount = (
			parseFloat(i.taxAmount) / parseFloat(rate.currencyRate)
		)?.toFixed(2)
		i.convertedTaxAmount = parseFloat(newConvertedTaxAmount)
		const newConvertedAmountBeforeTax = (
			parseFloat(i.amount) / parseFloat(rate.currencyRate)
		)?.toFixed(2)
		i.convertedAmountBeforeTax = parseFloat(newConvertedAmountBeforeTax)

		const copyTaxDetails = cloneDeep(i.taxDetails)

		copyTaxDetails.map((td) => {
			if (!td.taxAmount) {
			}
			const taxAmount = (
				parseFloat((td?.taxAmount || 0)?.toFixed(2)) /
				parseFloat(rate.currencyRate)
			)?.toFixed(2)
			td.taxAmount = parseFloat(taxAmount)
			if (td.taxableAmount != null) {
				td.taxableAmount = parseFloat(
					(
						parseFloat((td.taxableAmount || 0).toFixed(2)) /
						parseFloat(rate.currencyRate)
					).toFixed(2)
				)
			}
			return td
		})
		i.copyTaxDetails = copyTaxDetails
		const copySectionDetailsByQuote = cloneDeep(i.sectionDetailsByQuote)
		if (copySectionDetailsByQuote && copySectionDetailsByQuote.length > 0) {
			copySectionDetailsByQuote.map((sd) => {
				const amount = (
					parseFloat((sd.amount || 0)?.toFixed(2)) /
					parseFloat(rate.currencyRate)
				)?.toFixed(2)
				sd.amount = parseFloat(amount)
				return sd
			})
		}
		i.copySectionDetailsByQuote = copySectionDetailsByQuote
		const copySectionDetailsByAccSection = cloneDeep(
			i.sectionDetailsByAccSection
		)
		if (
			copySectionDetailsByAccSection &&
			copySectionDetailsByAccSection.length > 0
		) {
			copySectionDetailsByAccSection.map((sd) => {
				const amount = (
					parseFloat((sd.amount || 0)?.toFixed(2)) /
					parseFloat(rate.currencyRate)
				)?.toFixed(2)
				sd.amount = parseFloat(amount)
				return sd
			})
		}
		i.copySectionDetailsByAccSection = copySectionDetailsByAccSection

		return i
	})

	const creditTotal = convertRatesInvoices
		.filter((i) => i.invoiceType === 'credit')
		.reduce((a, b) => a + parseFloat(b.convertedAmount || 0), 0)
	const invoiceTotal = convertRatesInvoices
		.filter((i) => i.invoiceType !== 'credit')
		.reduce((a, b) => a + parseFloat(b.convertedAmount), 0)
	const creditNetTotal = convertRatesInvoices
		.filter((i) => i.invoiceType === 'credit')
		.reduce((a, b) => a + parseFloat(b.convertedAmountBeforeTax || 0), 0)
	const invoiceNetTotal = convertRatesInvoices
		.filter((i) => i.invoiceType !== 'credit')
		.reduce((a, b) => a + parseFloat(b.convertedAmountBeforeTax), 0)

	const totalAmount = (invoiceTotal - creditTotal)?.toFixed(2)
	const netAmount = (invoiceNetTotal - creditNetTotal)?.toFixed(2)
	const monthNames = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'July',
		'Aug',
		'Sept',
		'Oct',
		'Nov',
		'Dec',
	]
	const monthlyObjArray = []
	for (let i = 0; i < 12; i++) {
		const name = monthNames[i]
		const startDate = new Date(startYear, i, 1).toISOString()
		const endDate = new Date(startYear, i + 1).toISOString()
		const monthlyInv = convertRatesInvoices.filter(
			(pd) =>
				dayjs(pd.invoiceDate).isAfter(dayjs(startDate)) &&
				dayjs(pd.invoiceDate).isBefore(dayjs(endDate))
		)
		const creditNetTotal = monthlyInv
			.filter((i) => i.invoiceType === 'credit')
			.reduce(
				(a, b) => a + parseFloat(b.convertedAmountBeforeTax || 0),
				0
			)
		const invoiceNetTotal = monthlyInv
			.filter((i) => i.invoiceType !== 'credit')
			.reduce((a, b) => a + parseFloat(b.convertedAmountBeforeTax), 0)

		const preTaxAmtPerMonth = parseFloat(
			(invoiceNetTotal - creditNetTotal)?.toFixed(2)
		)
		const uv = preTaxAmtPerMonth
		const pv = preTaxAmtPerMonth
		const tv = preTaxAmtPerMonth
		const amt = preTaxAmtPerMonth
		const monthlyObj = {
			name,
			monthlyInv,
			preTaxAmtPerMonth,
			uv,
			pv,
			tv,
			amt,
		}
		// Only if we want to stop graph at current month and not show for future months
		// const currDate = new Date().toISOString()
		// if (currDate < startDate) {
		//   monthlyObj = {
		//     name,
		//     monthlyInv,
		//     preTaxAmtPerMonth,
		//   }
		// }
		monthlyObjArray.push(monthlyObj)
	}
	totalsObject = {
		convertedInvoices: convertRatesInvoices,
		currencySymbol,
		totalAmount,
		netAmount,
		monthlyObjArray,
	}

	return totalsObject
}
function getAccountTotals(
	bankAccountsData,
	currencyRates,
	companyInfo,
	startDate,
	endDate
) {
	let totalsObject = {}
	let currencySymbol
	if (Object.keys(companyInfo).length !== 0) {
		const currentCurrency = currency.filter(
			(c) => c.code === (companyInfo?.accountCurrency || 'EUR')
		)[0]
		currencySymbol = currentCurrency?.symbol
	}
	let cloneBankAccountHistory
	if (startDate && endDate) {
		const copyBankAccountsData = cloneDeep(bankAccountsData)

		const selectedBankAccountsData = copyBankAccountsData.filter(
			(acc) => acc.isSelected
		)

		const selectedBalanceHistory = selectedBankAccountsData?.map(
			(account) => {
				const history = account.balanceHistory

				const filterHistory = history.filter(
					(h) =>
						dayjs(h.updated_at).isAfter(dayjs(startDate)) &&
						dayjs(h.updated_at).isBefore(dayjs(endDate))
				)

				if (filterHistory.length > 0) {
					const sortedHistory = orderBy(
						filterHistory,
						['updated_at'],
						['asc']
					)

					const newHistory = sortedHistory[0]

					account.dashboardBalanceHistory = newHistory
					return account
				}
				account.dashboardBalanceHistory = {
					balance: 0,
					updated_at: dayjs(endDate).toISOString(),
				}
				return account
			}
		)

		cloneBankAccountHistory = selectedBalanceHistory
	} else {
		const copyBankAccountsData = cloneDeep(bankAccountsData)

		const selectedBankAccountsData = copyBankAccountsData.filter(
			(acc) => acc.isSelected
		)

		const selectedBalanceHistory = selectedBankAccountsData?.map(
			(account) => {
				const history = account.balanceHistory

				if (history.length > 0) {
					const sortedHistory = orderBy(
						history,
						['updated_at'],
						['asc']
					)

					const newHistory = sortedHistory[0]

					account.dashboardBalanceHistory = newHistory
					return account
				}
				account.dashboardBalanceHistory = {
					balance: 0,
					updated_at: dayjs(endDate).toISOString(),
				}
				return account
			}
		)

		cloneBankAccountHistory = selectedBalanceHistory
	}

	console.log('cloneBankAccountHistory: ', cloneBankAccountHistory)
	const convertBankAccHistory = cloneBankAccountHistory.map((i) => {
		const filteredRate = currencyRates?.[0]?.rates?.filter(
			(r) => r.currencyName === i.currency_code
		)

		let rate
		if (filteredRate && filteredRate.length > 0) {
			rate = filteredRate[0]
		} else {
			rate = {
				currencyRate: 1,
			}
		}
		const newConvertedBalance = (
			parseFloat(i.balance) / parseFloat(rate.currencyRate)
		)?.toFixed(2)
		i.convertedBalance = parseFloat(newConvertedBalance)
		return i
	})

	const totalAmount = convertBankAccHistory.reduce(
		(a, b) => a + parseFloat(b.convertedBalance || 0),
		0
	)

	totalsObject = {
		convertBankAcc: convertBankAccHistory,
		currencySymbol,
		totalAmount,
	}

	return totalsObject
}
function getAccountTotalsPerMonth(
	bankAccountsData,
	currencyRates,
	companyInfo,
	startYear = `${dayjs().get('year')}`,
	endYear = `${dayjs().get('year') + 1}`
) {
	let totalsObject = {}
	let currencySymbol
	if (Object.keys(companyInfo).length !== 0) {
		const currentCurrency = currency.filter(
			(c) => c.code === (companyInfo?.accountCurrency || 'EUR')
		)[0]
		currencySymbol = currentCurrency?.symbol
	}
	let cloneBankAccount
	if (startYear && endYear) {
		const startDate = dayjs(`1/1/${startYear}`)
		const endDate = dayjs(`1/1/${endYear}`)
		const copyBankAccountsData = cloneDeep(bankAccountsData)

		const selectedBankAccountsData = copyBankAccountsData.filter(
			(acc) => acc.isSelected
		)

		const selectedBalanceHistory = selectedBankAccountsData?.map(
			(account) => {
				const history = account.balanceHistory

				const filterHistory = history.filter(
					(h) =>
						dayjs(h.updated_at).isAfter(dayjs(startDate)) &&
						dayjs(h.updated_at).isBefore(dayjs(endDate))
				)

				if (filterHistory.length > 0) {
					const sortedHistory = orderBy(
						filterHistory,
						['updated_at'],
						['asc']
					)

					const newHistory = sortedHistory[0]

					account.dashboardBalanceHistory = newHistory
					return account
				}
				account.dashboardBalanceHistory = {
					balance: 0,
					updated_at: dayjs().toISOString(),
				}
				return account
			}
		)

		cloneBankAccount = selectedBalanceHistory
	} else {
		const copyBankAccountsData = cloneDeep(bankAccountsData)

		const selectedBankAccountsData = copyBankAccountsData.filter(
			(acc) => acc.isSelected
		)

		const selectedBalanceHistory = selectedBankAccountsData?.map(
			(account) => {
				const history = account.balanceHistory

				if (history.length > 0) {
					const sortedHistory = orderBy(
						history,
						['updated_at'],
						['asc']
					)

					const newHistory = sortedHistory[0]

					account.dashboardBalanceHistory = newHistory
					return account
				}
				account.dashboardBalanceHistory = {
					balance: 0,
					updated_at: dayjs().toISOString(),
				}
				return account
			}
		)

		cloneBankAccount = selectedBalanceHistory
	}
	const allBalanceHistories = []
	const convertBankAccHistory = cloneBankAccount.map((i) => {
		const filteredRate = currencyRates?.[0]?.rates?.filter(
			(r) => r.currencyName === i.currency_code
		)
		const balanceHistory = i.balanceHistory

		let rate
		if (filteredRate && filteredRate.length > 0) {
			rate = filteredRate[0]
		} else {
			rate = {
				currencyRate: 1,
			}
		}
		const convertedBalanceHistory = []
		for (const each of balanceHistory) {
			const convertedHistoryAmt = parseFloat(
				(
					parseFloat(each.balance) / parseFloat(rate.currencyRate)
				)?.toFixed(2)
			)
			const newObj = {
				bankId: i.id,
				bankName: i.name,
				convertedBalance: convertedHistoryAmt,
				updated_at: each.updated_at,
			}
			allBalanceHistories.push(newObj)
			convertedBalanceHistory.push(newObj)
		}
		const newConvertedBalance = (
			parseFloat(i.balance) / parseFloat(rate.currencyRate)
		)?.toFixed(2)
		i.convertedBalance = parseFloat(newConvertedBalance)

		// const currentConvertedBalance = (parseFloat(i.amount) / parseFloat(rate.currencyRate))?.toFixed(
		//   2
		// )
		// i.currentConvertedBalance = parseFloat(currentConvertedBalance)

		i.convertedBalanceHistory = convertedBalanceHistory
		return i
	})

	const totalAmount = convertBankAccHistory.reduce(
		(a, b) => a + parseFloat(b.convertedBalance || 0),
		0
	)

	const monthNames = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'July',
		'Aug',
		'Sept',
		'Oct',
		'Nov',
		'Dec',
	]
	const monthlyObjArray = []

	for (let i = 0; i < 12; i++) {
		const name = monthNames[i]
		const startDate = new Date(startYear, i, 1).toISOString()
		const endDate = new Date(startYear, i + 1).toISOString()
		const monthlyAllBankAccountHistory = allBalanceHistories.filter(
			(pd) =>
				dayjs(pd.updated_at).isAfter(dayjs(startDate)) &&
				dayjs(pd.updated_at).isBefore(dayjs(endDate))
		)

		const balanceForAllAccounts = parseFloat(
			monthlyAllBankAccountHistory
				.reduce((a, b) => a + parseFloat(b.convertedBalance || 0), 0)
				?.toFixed(2)
		)
		const balanceForEachAccount = monthlyAllBankAccountHistory.map(
			(each) => {
				each.name = name
				each.uv = each.convertedBalance
				each.pv = each.convertedBalance
				each.tv = each.convertedBalance
				each.amt = each.convertedBalance
				return each
			}
		)

		const uv = balanceForAllAccounts
		const pv = balanceForAllAccounts
		const tv = balanceForAllAccounts
		const amt = balanceForAllAccounts
		let monthlyObjForAllAccounts = {
			name,
			monthlyAllBankAccountHistory,
			balanceForAllAccounts,
			balanceForEachAccount,
			uv,
			pv,
			tv,
			amt,
		}
		const currDate = new Date().toISOString()
		if (currDate < startDate) {
			monthlyObjForAllAccounts = {
				name,
				monthlyAllBankAccountHistory,
				balanceForAllAccounts,
				balanceForEachAccount,
			}
		}
		monthlyObjArray.push(monthlyObjForAllAccounts)
	}

	totalsObject = {
		convertBankAcc: convertBankAccHistory,
		currencySymbol,
		totalAmount,
		monthlyObjArray,
	}

	return totalsObject
}
function getTransactionTotalsPerMonth(
	bankAccountData,
	transactionsData,
	currencyRates,
	companyInfo,
	startYear = `${dayjs().get('year')}`,
	endYear = `${dayjs().get('year') + 1}`
) {
	let totalsObject = {}
	let currencySymbol
	if (Object.keys(companyInfo).length !== 0) {
		const currentCurrency = currency.filter(
			(c) => c.code === (companyInfo?.accountCurrency || 'EUR')
		)[0]
		currencySymbol = currentCurrency?.symbol
	}
	let cloneTransactionsData
	if (startYear && endYear) {
		const startDate = dayjs(`1/1/${startYear}`)
		const endDate = dayjs(`1/1/${endYear}`)
		const copyTransactionsData = cloneDeep(transactionsData)

		cloneTransactionsData = copyTransactionsData.filter(
			(pd) =>
				dayjs(pd.date).isAfter(dayjs(startDate)) &&
				dayjs(pd.date).isBefore(dayjs(endDate))
		)
	} else {
		cloneTransactionsData = cloneDeep(transactionsData)
	}

	const convertTransactionsData = cloneTransactionsData.map((i) => {
		const filteredRate = currencyRates?.[0]?.rates?.filter(
			(r) => r.currencyName === i.clientCurrency
		)

		let rate
		if (filteredRate && filteredRate.length > 0) {
			rate = filteredRate[0]
		} else {
			rate = {
				currencyRate: 1,
			}
		}

		const newConvertedAmount = parseFloat(
			(parseFloat(i.amount) / parseFloat(rate.currencyRate))?.toFixed(2)
		)
		i.convertedAmount = newConvertedAmount

		return i
	})

	const revenueTotal = convertTransactionsData
		.filter((i) => i.transactionType === 'revenue')
		.reduce((a, b) => a + parseFloat(b.convertedAmount || 0), 0)
	const costTotal = convertTransactionsData
		.filter((i) => i.transactionType === 'cost')
		.reduce((a, b) => a + parseFloat(b.convertedAmount), 0)

	const totalAmount = parseFloat((revenueTotal - costTotal)?.toFixed(2))
	const monthNames = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'July',
		'Aug',
		'Sept',
		'Oct',
		'Nov',
		'Dec',
	]
	const monthlyObjArray = []
	const monthlyObjPerAccountArray = []
	for (let i = 0; i < 12; i++) {
		const name = monthNames[i]
		const startDate = new Date(startYear, i, 1).toISOString()
		const endDate = new Date(startYear, i + 1).toISOString()
		const monthlyTransactions = convertTransactionsData.filter(
			(pd) =>
				dayjs(pd.date).isAfter(dayjs(startDate)) &&
				dayjs(pd.date).isBefore(dayjs(endDate))
		)
		const revenueMonthlyTotal = monthlyTransactions
			.filter((i) => i.transactionType === 'revenue')
			.reduce((a, b) => a + parseFloat(b.convertedAmount || 0), 0)
		const costMonthlyTotal = monthlyTransactions
			.filter((i) => i.transactionType === 'cost')
			.reduce((a, b) => a + parseFloat(b.convertedAmount), 0)

		const amtPerMonth = parseFloat(
			(revenueMonthlyTotal - costMonthlyTotal)?.toFixed(2)
		)
		const uv = parseFloat(revenueMonthlyTotal.toFixed(2))
		const pv = Math.abs(parseFloat(costMonthlyTotal.toFixed(2)))
		const tv = amtPerMonth
		const amt = amtPerMonth
		let monthlyObj = {
			name,
			monthlyTransactions,
			amtPerMonth,
			uv,
			pv,
			tv,
			amt,
		}
		const currDate = new Date().toISOString()
		if (currDate < startDate) {
			monthlyObj = {
				name,
				monthlyTransactions,
				amtPerMonth,
				amt,
			}
		}
		monthlyObjArray.push(monthlyObj)

		// Filter transaction for each account
		for (const eachBankAccount of bankAccountData) {
			const transactionsPerAccount = monthlyTransactions?.filter(
				(t) => t.account_id === parseInt(eachBankAccount.id)
			)
			const revenueMonthlyTotal = transactionsPerAccount
				.filter((i) => i.transactionType === 'revenue')
				.reduce((a, b) => a + parseFloat(b.convertedAmount || 0), 0)
			const costMonthlyTotal = transactionsPerAccount
				.filter((i) => i.transactionType === 'cost')
				.reduce((a, b) => a + parseFloat(b.convertedAmount), 0)

			const amtPerMonth = parseFloat(
				(revenueMonthlyTotal - costMonthlyTotal)?.toFixed(2)
			)
			const uv = parseFloat(revenueMonthlyTotal.toFixed(2))
			const pv = Math.abs(parseFloat(costMonthlyTotal.toFixed(2)))
			const tv = amtPerMonth
			const amt = amtPerMonth
			let objPerAccountPerMonth = {
				name,
				bankId: eachBankAccount.id,
				bankName: eachBankAccount.name,
				amtPerMonth,
				uv,
				pv,
				tv,
				amt,
			}
			const currDate = new Date().toISOString()
			if (currDate < startDate) {
				objPerAccountPerMonth = {
					name,
					bankId: eachBankAccount.id,
					bankName: eachBankAccount.name,
					amtPerMonth,
				}
			}
			monthlyObjPerAccountArray.push(objPerAccountPerMonth)
		}
	}
	totalsObject = {
		convertedTransactions: convertTransactionsData,
		currencySymbol,
		totalAmount,
		monthlyObjArray,
		monthlyObjPerAccountArray,
	}

	return totalsObject
}
function getTransactionAndAccountTotalsPerMonth(
	bankAccountsData,
	transactionsData,
	currencyRates,
	companyInfo,
	startYear = `${dayjs().get('year')}`,
	endYear = `${dayjs().get('year') + 1}`
) {
	const bankAccountObj = getAccountTotalsPerMonth(
		bankAccountsData,
		currencyRates,
		companyInfo,
		startYear,
		endYear
	)
	const monthlyAccData = bankAccountObj?.monthlyObjArray

	const transactionsObj = getTransactionTotalsPerMonth(
		bankAccountsData,
		transactionsData,
		currencyRates,
		companyInfo,
		startYear,
		endYear
	)
	const monthlyTransactionsData = transactionsObj?.monthlyObjArray
	const monthlyTransactionsPerAccData =
		transactionsObj?.monthlyObjPerAccountArray
	const monthNames = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'July',
		'Aug',
		'Sept',
		'Oct',
		'Nov',
		'Dec',
	]
	const monthlyObjArray = []
	const transactionsPerAccountPerMonth = []

	for (let i = 0; i < 12; i++) {
		const name = monthNames[i]
		const startDate = new Date(startYear, i, 1).toISOString()
		const currDate = new Date().toISOString()
		let newObj = {
			name,
			uv: monthlyTransactionsData[i].uv,
			pv: monthlyTransactionsData[i].pv,
			tv: monthlyAccData[i]?.tv,
			amt: monthlyTransactionsData[i].totalAmount,
		}
		if (currDate < startDate) {
			newObj = {
				name,
				amt: monthlyTransactionsData[i].totalAmount,
			}
		}
		monthlyObjArray.push(newObj)

		// Individual
		for (const eachAcc of bankAccountsData) {
			console.log(
				'monthlyAccData?.balanceForEachAccount: ',
				monthlyAccData[i]?.balanceForEachAccount
			)
			const balanceForEachAccount = monthlyAccData[
				i
			]?.balanceForEachAccount?.find((b) => b.bankId === eachAcc.id)

			const transactionForEachAccount =
				monthlyTransactionsPerAccData?.find(
					(t) => t.bankId === eachAcc.id && t.name === name
				)

			let newObj = {
				name,
				uv: transactionForEachAccount?.uv,
				pv: transactionForEachAccount?.pv,
				tv: balanceForEachAccount?.tv ?? 0,
				amt: transactionForEachAccount?.uv,
				bankId: eachAcc.id,
				bankName: eachAcc.name,
			}

			if (currDate < startDate) {
				newObj = {
					name,
					amt: transactionForEachAccount?.uv,
					bankId: eachAcc.id,
					bankName: eachAcc.name,
				}
			}
			transactionsPerAccountPerMonth.push(newObj)
		}
	}
	const totalsObject = {
		monthlyObjArray,
		transactionsPerAccountPerMonth,
	}

	return totalsObject
}

function getPurchaseTotals(purchases, currencyRates, companyInfo) {
	let totalsObject = {}
	let currencySymbol
	if (Object.keys(companyInfo).length !== 0) {
		const currentCurrency = currency.filter(
			(c) => c.code === (companyInfo?.accountCurrency || 'EUR')
		)[0]
		currencySymbol = currentCurrency?.symbol
	}
	const clonePurchases = cloneDeep(purchases)

	const convertRatesPurchases = clonePurchases.map((i) => {
		const filteredRate = currencyRates?.[0]?.rates?.filter(
			(r) => r.currencyName === i.currency
		)
		let rate
		if (filteredRate && filteredRate.length > 0) {
			rate = filteredRate[0]
		} else {
			rate = {
				currencyRate: 1,
			}
		}
		const newProvisionalTotal = (
			parseFloat(i.provisionalTotal) / parseFloat(rate.currencyRate)
		)?.toFixed(2)
		i.convertedProvisionalTotal = parseFloat(newProvisionalTotal)

		return i
	})

	const purchaseProvisionalTotal = convertRatesPurchases
		.reduce((a, b) => a + parseFloat(b.convertedProvisionalTotal || 0), 0)
		?.toFixed(2)

	totalsObject = {
		convertedPurchases: convertRatesPurchases,
		currencySymbol,
		purchaseProvisionalTotal,
	}

	return totalsObject
}

function getDraftPurchaseTotals(
	purchases,
	currencyRates,
	companyInfo,
	startDate,
	endDate
) {
	let totalsObject = {}
	let currencySymbol
	if (Object.keys(companyInfo).length !== 0) {
		const currentCurrency = currency.filter(
			(c) => c.code === (companyInfo?.accountCurrency || 'EUR')
		)[0]
		currencySymbol = currentCurrency?.symbol
	}
	let clonePurchases = cloneDeep(purchases).filter(
		(element) => element.paymentStatus === 'Draft'
	)

	if (startDate && endDate) {
		const copyPurchases = cloneDeep(clonePurchases)
		clonePurchases = copyPurchases.filter(
			(p) =>
				dayjs(p.createdOn).isAfter(dayjs(startDate)) &&
				dayjs(p.createdOn).isBefore(dayjs(endDate))
		)
	}

	const convertRatesPurchases = clonePurchases.map((i) => {
		const filteredRate = currencyRates?.[0]?.rates?.filter(
			(r) => r.currencyName === i.currency
		)
		let rate
		if (filteredRate && filteredRate.length > 0) {
			rate = filteredRate[0]
		} else {
			rate = {
				currencyRate: 1,
			}
		}
		const newProvisionalTotal = (
			parseFloat(i.provisionalTotal) / parseFloat(rate.currencyRate)
		).toFixed(2)
		i.convertedProvisionalTotal = parseFloat(newProvisionalTotal)

		const newConvertedAmount = (
			parseFloat(i.invoiceTotal) / parseFloat(rate.currencyRate)
		).toFixed(2)
		i.convertedAmount = parseFloat(newConvertedAmount)

		const newConvertedTaxAmount = (
			parseFloat(i.taxAmount) / parseFloat(rate.currencyRate)
		).toFixed(2)
		i.convertedTaxAmount = parseFloat(newConvertedTaxAmount)
		const newConvertedAmountBeforeTax = (
			parseFloat(i.invoiceTotal - i.taxAmount) /
			parseFloat(rate.currencyRate)
		).toFixed(2)
		i.convertedAmountBeforeTax = parseFloat(newConvertedAmountBeforeTax)
		return i
	})

	const purchaseInvoiceTotal = convertRatesPurchases
		.reduce((a, b) => a + parseFloat(b.convertedAmount || 0), 0)
		.toFixed(2)
	const purchaseTaxTotal = convertRatesPurchases
		.reduce((a, b) => a + parseFloat(b.convertedTaxAmount || 0), 0)
		.toFixed(2)
	const purchaseProvisionalTotal = convertRatesPurchases
		.reduce((a, b) => a + parseFloat(b.convertedProvisionalTotal || 0), 0)
		.toFixed(2)

	totalsObject = {
		convertedPurchases: convertRatesPurchases,
		currencySymbol,
		purchaseInvoiceTotal,
		purchaseTaxTotal,
		purchaseProvisionalTotal,
	}

	return totalsObject
}

function getExportTotals(
	preparePurchases,
	currencyRates,
	companyInfo,
	startDate,
	endDate
) {
	let totalsObject = {}
	let currencySymbol
	if (!companyInfo || !currencyRates || !preparePurchases) return
	if (Object.keys(companyInfo).length !== 0) {
		const currentCurrency = currency.filter(
			(c) => c.code === (companyInfo?.accountCurrency || 'EUR')
		)[0]
		currencySymbol = currentCurrency?.symbol
	}
	let clonepreparePurchases
	if (startDate && endDate) {
		const copyPreparePurchasesData = cloneDeep(preparePurchases)

		clonepreparePurchases = copyPreparePurchasesData.filter(
			(pd) =>
				dayjs(pd.invoiceDate).isAfter(dayjs(startDate)) &&
				dayjs(pd.invoiceDate).isBefore(dayjs(endDate))
		)
	} else {
		clonepreparePurchases = cloneDeep(preparePurchases)
	}
	const convertRatesPreparePurchases = clonepreparePurchases.map((i) => {
		const filteredRate = currencyRates?.[0]?.rates?.filter(
			(r) => r.currencyName === i.currency
		)
		let rate
		if (filteredRate && filteredRate.length > 0) {
			rate = filteredRate[0]
		} else {
			rate = {
				currencyRate: 1,
			}
		}
		let currentTotal = 0

		if (i.totalAmount || i.totalAmount === 0) {
			currentTotal = i.totalAmount
		} else if (
			(!i.totalAmount || i.totalAmount !== 0) &&
			(i.ocrTotalAmount || i.ocrTotalAmount === 0)
		) {
			currentTotal = i.ocrTotalAmount
		}

		const newConvertedAmount = (
			parseFloat(currentTotal) / parseFloat(rate.currencyRate)
		)?.toFixed(2)
		i.convertedAmount = parseFloat(newConvertedAmount)

		console.log('i?.taxAmountDetails: ', i?.taxAmountDetails)
		const convertedTaxAmtArry = []
		let convertedTaxAmountTotal = 0
		i?.taxAmountDetails?.map((t) => {
			const convertedTax = parseFloat(
				(t?.taxAmount / parseFloat(rate.currencyRate))?.toFixed(2)
			)
			convertedTaxAmountTotal += convertedTax
			const newObj = {
				...t,
				taxAmount: convertedTax,
			}
			convertedTaxAmtArry.push(newObj)
		})
		console.log('convertedTaxAmtArry: ', convertedTaxAmtArry)
		i.convertedTaxAmountDetails = convertedTaxAmtArry

		// const newConvertedTaxAmount = (parseFloat(currentTax) / parseFloat(rate.currencyRate))?.toFixed(
		//   2
		// )
		i.convertedTaxAmountTotal = parseFloat(
			convertedTaxAmountTotal.toFixed(2)
		)
		const convertedNetAmtArry = []
		let convertedNetAmountTotal = 0
		i?.netAmountDetails?.map((t) => {
			const convertedNet = parseFloat(
				(t?.netAmount / parseFloat(rate.currencyRate))?.toFixed(2)
			)
			convertedNetAmountTotal += convertedNet
			const newObj = {
				...t,
				netAmount: convertedNet,
			}
			convertedNetAmtArry.push(newObj)
		})
		console.log('convertedNetAmtArry: ', convertedNetAmtArry)
		i.convertedNetAmountDetails = convertedNetAmtArry

		i.convertedAmountBeforeTax = parseFloat(
			convertedNetAmountTotal.toFixed(2)
		)

		return i
	})

	const preparePurchaseTotal = convertRatesPreparePurchases
		.reduce((a, b) => a + parseFloat(b.convertedAmount || 0), 0)
		?.toFixed(2)
	const preparePurchaseTaxTotal = convertRatesPreparePurchases
		.reduce((a, b) => a + parseFloat(b.convertedTaxAmountTotal || 0), 0)
		?.toFixed(2)
	const preparePurchaseNetTotal = convertRatesPreparePurchases
		.reduce((a, b) => a + parseFloat(b.convertedAmountBeforeTax || 0), 0)
		?.toFixed(2)

	totalsObject = {
		convertedPreparePurchases: convertRatesPreparePurchases,
		currencySymbol,
		preparePurchaseTotal,
		preparePurchaseTaxTotal,
		preparePurchaseNetTotal,
	}

	return totalsObject
}
function getExportTotalsByMonth(
	preparePurchases,
	currencyRates,
	companyInfo,
	startYear = `${dayjs().get('year')}`,
	endYear = `${dayjs().get('year') + 1}`
) {
	let totalsObject = {}
	let currencySymbol
	if (!companyInfo || !currencyRates || !preparePurchases) return
	if (Object.keys(companyInfo).length !== 0) {
		const currentCurrency = currency.filter(
			(c) => c.code === (companyInfo?.accountCurrency || 'EUR')
		)[0]
		currencySymbol = currentCurrency?.symbol
	}
	let clonepreparePurchases
	if (startYear && endYear) {
		const startDate = dayjs(`1/1/${startYear}`)
		const endDate = dayjs(`1/1/${endYear}`)
		const copyPreparePurchasesData = cloneDeep(preparePurchases)

		clonepreparePurchases = copyPreparePurchasesData.filter(
			(pd) =>
				dayjs(pd.invoiceDate).isAfter(dayjs(startDate)) &&
				dayjs(pd.invoiceDate).isBefore(dayjs(endDate))
		)
	} else {
		clonepreparePurchases = cloneDeep(preparePurchases)
	}
	const convertRatesPreparePurchases = clonepreparePurchases.map((i) => {
		const filteredRate = currencyRates?.[0]?.rates?.filter(
			(r) => r.currencyName === i.currency
		)
		let rate
		if (filteredRate && filteredRate.length > 0) {
			rate = filteredRate[0]
		} else {
			rate = {
				currencyRate: 1,
			}
		}
		let currentTotal = 0
		// let currentTax = 0
		// let currentNet = 0
		if (i.totalAmount || i.totalAmount === 0) {
			currentTotal = i.totalAmount
		} else if (
			(!i.totalAmount || i.totalAmount !== 0) &&
			(i.ocrTotalAmount || i.ocrTotalAmount === 0)
		) {
			currentTotal = i.ocrTotalAmount
		}

		// if (i.taxAmount || i.taxAmount === 0) {
		//   currentTax = i.taxAmount
		// } else if ((!i.taxAmount || i.taxAmount !== 0) && (i.ocrTaxAmount || i.ocrTaxAmount === 0)) {
		//   currentTax = i.ocrTaxAmount
		// }

		// if (i.netAmount || i.netAmount === 0) {
		// 	currentNet = i.netAmount
		// } else if (
		// 	(!i.netAmount || i.netAmount !== 0) &&
		// 	(i.ocrNetAmount || i.ocrNetAmount === 0)
		// ) {
		// 	currentNet = i.ocrNetAmount
		// }

		const newConvertedAmount = (
			parseFloat(currentTotal) / parseFloat(rate.currencyRate)
		)?.toFixed(2)
		i.convertedAmount = parseFloat(newConvertedAmount)

		const convertedTaxAmtArry = []
		let convertedTaxAmountTotal = 0
		i?.taxAmountDetails?.map((t) => {
			const convertedTax = parseFloat(
				(t?.taxAmount / parseFloat(rate.currencyRate))?.toFixed(2)
			)
			convertedTaxAmountTotal += convertedTax
			const newObj = {
				...t,
				taxAmount: convertedTax,
			}
			convertedTaxAmtArry.push(newObj)
		})
		console.log('convertedTaxAmtArry: ', convertedTaxAmtArry)
		i.convertedTaxAmountDetails = convertedTaxAmtArry

		i.convertedTaxAmountTotal = parseFloat(
			convertedTaxAmountTotal.toFixed(2)
		)
		const convertedNetAmtArry = []
		let convertedNetAmountTotal = 0
		i?.netAmountDetails?.map((t) => {
			const convertedNet = parseFloat(
				(t?.netAmount / parseFloat(rate.currencyRate))?.toFixed(2)
			)
			convertedNetAmountTotal += convertedNet
			const newObj = {
				...t,
				netAmount: convertedNet,
			}
			convertedNetAmtArry.push(newObj)
		})
		console.log('convertedNetAmtArry: ', convertedNetAmtArry)
		i.convertedNetAmountDetails = convertedNetAmtArry

		i.convertedAmountBeforeTax = parseFloat(
			convertedNetAmountTotal.toFixed(2)
		)

		return i
	})

	const preparePurchaseTotal = convertRatesPreparePurchases
		.reduce((a, b) => a + parseFloat(b.convertedAmount || 0), 0)
		?.toFixed(2)
	const preparePurchaseTaxTotal = convertRatesPreparePurchases
		.reduce((a, b) => a + parseFloat(b.convertedTaxAmountTotal || 0), 0)
		?.toFixed(2)
	const preparePurchaseNetTotal = convertRatesPreparePurchases
		.reduce((a, b) => a + parseFloat(b.convertedAmountBeforeTax || 0), 0)
		?.toFixed(2)

	const monthNames = [
		'Jan',
		'Feb',
		'Mar',
		'Apr',
		'May',
		'Jun',
		'July',
		'Aug',
		'Sept',
		'Oct',
		'Nov',
		'Dec',
	]
	const monthlyObjArray = []
	for (let i = 0; i < 12; i++) {
		const name = monthNames[i]
		const startDate = new Date(startYear, i, 1).toISOString()
		const endDate = new Date(startYear, i + 1).toISOString()
		const monthlyPreparePurchase = convertRatesPreparePurchases.filter(
			(pd) =>
				dayjs(pd.invoiceDate).isAfter(dayjs(startDate)) &&
				dayjs(pd.invoiceDate).isBefore(dayjs(endDate))
		)
		console.log('monthlyPreparePurchase: ', monthlyPreparePurchase)

		const preTaxAmtPerMonth = parseFloat(
			monthlyPreparePurchase
				.reduce(
					(a, b) => a + parseFloat(b.convertedAmountBeforeTax || 0),
					0
				)
				?.toFixed(2)
		)
		console.log('preTaxAmtPerMonth: ', preTaxAmtPerMonth)
		const uv = preTaxAmtPerMonth
		const pv = preTaxAmtPerMonth
		const tv = preTaxAmtPerMonth
		const amt = preTaxAmtPerMonth
		const monthlyObj = {
			name,
			monthlyPreparePurchase,
			preTaxAmtPerMonth,
			uv,
			pv,
			tv,
			amt,
		}
		// Only if we want to stop graph at current month and not show for future months
		// const currDate = new Date().toISOString()
		// if (currDate < startDate) {
		//   monthlyObj = {
		//     name,
		//     monthlyPreparePurchase,
		//     preTaxAmtPerMonth,
		//     amt,
		//   }
		// }
		monthlyObjArray.push(monthlyObj)
	}
	totalsObject = {
		convertedPreparePurchases: convertRatesPreparePurchases,
		currencySymbol,
		preparePurchaseTotal,
		preparePurchaseTaxTotal,
		preparePurchaseNetTotal,
		monthlyObjArray,
	}

	return totalsObject
}

function getAllTotals(
	bankAccountsData,
	invoices,
	preparePurchases,
	transactionsData,
	currencyRates,
	companyInfo,
	startYear,
	endYear
) {
	const revenueObj = getInvoiceTotalsByMonth(
		invoices,
		currencyRates,
		companyInfo,
		startYear,
		endYear
	)
	const expensesObj = getExportTotalsByMonth(
		preparePurchases,
		currencyRates,
		companyInfo,
		startYear,
		endYear
	)
	const bankAccountObj = getAccountTotalsPerMonth(
		bankAccountsData,
		currencyRates,
		companyInfo,
		startYear,
		endYear
	)
	const transactionsObj = getTransactionTotalsPerMonth(
		bankAccountsData,
		transactionsData,
		currencyRates,
		companyInfo,
		startYear,
		endYear
	)
	const transactionsAndAccObj = getTransactionAndAccountTotalsPerMonth(
		bankAccountsData,
		transactionsData,
		currencyRates,
		companyInfo,
		startYear,
		endYear
	)

	const revenueProfitArray = []
	const diffRevenueArray = []

	for (let i = 0; i < 12; i++) {
		const startDate = new Date(startYear, i, 1).toISOString()
		// Only if we want to stop graph at current month and not show for future months
		// const currDate = new Date().toISOString()

		const profitObj = {
			name: revenueObj?.monthlyObjArray?.[i]?.name ?? 0,
			pv: revenueObj?.monthlyObjArray?.[i]?.pv ?? 0,
			uv: expensesObj?.monthlyObjArray?.[i]?.pv ?? 0,
			tv: parseFloat(
				(revenueObj?.monthlyObjArray?.[i]?.pv ?? 0) -
					(expensesObj?.monthlyObjArray?.[i]?.pv ?? 0)
			).toFixed(2),
		}
		// if (currDate < startDate) {
		//   profitObj = {
		//     name: revenueObj?.monthlyObjArray?.[i]?.name ?? 0,
		//   }
		// }
		revenueProfitArray.push(profitObj)
		const diffObj = {
			name: revenueObj?.monthlyObjArray?.[i]?.name ?? 0,
			pv: revenueObj?.monthlyObjArray?.[i]?.pv ?? 0,
			uv: expensesObj?.monthlyObjArray?.[i]?.pv ?? 0,
			tv: parseFloat(
				(revenueObj?.monthlyObjArray?.[i]?.pv ?? 0) -
					(expensesObj?.monthlyObjArray?.[i]?.pv ?? 0)
			).toFixed(2),
		}
		// if (currDate < startDate) {
		//   diffObj = {
		//     name: revenueObj?.monthlyObjArray?.[i]?.name ?? 0,
		//   }
		// }
		diffRevenueArray.push(diffObj)
	}
	const totalRevenueProfit = parseFloat(
		(revenueObj?.netAmount ?? 0) -
			(expensesObj?.preparePurchaseNetTotal ?? 0)
	).toFixed(2)
	const totalRevenueDiff = parseFloat(
		(revenueObj?.netAmount ?? 0) -
			(expensesObj?.preparePurchaseNetTotal ?? 0)
	).toFixed(2)
	const revenueProfitObj = {
		revenueProfitArray,
		totalRevenueProfit,
	}
	const diffRevenueObj = {
		diffRevenueArray,
		totalRevenueDiff,
	}
	const allGraphInfo = {
		revenueData: revenueObj,
		expensesData: expensesObj,
		revenueProfitData: revenueProfitObj,
		diffRevenueData: diffRevenueObj,
		bankAccountData: bankAccountObj,
		transactionsAndAccData: transactionsAndAccObj,
	}

	return allGraphInfo
}

export {
	getAccountTotals,
	getAccountTotalsPerMonth,
	getAllTotals,
	getDraftPurchaseTotals,
	getExportTotals,
	getExportTotalsByMonth,
	getInvoiceTotals,
	getInvoiceTotalsByMonth,
	getPurchaseTotals,
	getTransactionAndAccountTotalsPerMonth,
	getTransactionTotalsPerMonth,
}
